"use client"

import "./VoteDetails.css"

const VoteDetails = ({ voteData, currentUserId, onEditNote }) => {
  if (!voteData) {
    return null
  }

  return (
    <div className="vote-details-container">
      {voteData.totalVotes !== undefined && (
        <div className="vote-summary">
          <p>Total Votes: {voteData.totalVotes}</p>
          <p>Love: {voteData.loveVotes}</p>
          <p>Like: {voteData.likeVotes}</p>
          <p>Skip: {voteData.skipVotes}</p>
        </div>
      )}

      {voteData.userDetails && voteData.userDetails.length > 0 && (
        <div className="vote-details">
          <div className="voters-list">
            {voteData.userDetails.map((detail, index) => (
              <div key={index} className="voter-item">
                <div className="voter-info">
                  <div className="vote-emoji">
                    {detail.vote === "love" && "❤️"}
                    {detail.vote === "like" && "👍"}
                    {detail.vote === "skip" && "👎"}
                  </div>
                  <div className="voter-details">
                    <span className="voter-name">{detail.nickname || `User ${detail.userId.slice(-4)}`}</span>

                    {/* Show note if it exists */}
                    {detail.note && (
                      <div
                        className={`voter-note ${detail.userId === currentUserId ? "clickable-note" : ""}`}
                        onClick={() => detail.userId === currentUserId && onEditNote && onEditNote(detail.note)}
                        title={detail.userId === currentUserId ? "Click to edit note" : ""}
                      >
                        {detail.note}
                      </div>
                    )}
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  )
}

export default VoteDetails
